import { Menu } from "@/types";
import { atom } from "jotai";

const deliveryMenuAtom = atom<Menu | null>(null)

export default deliveryMenuAtom
